// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveyFullSurveySessionValuesModel {
    static getAttributeTypeMap() {
        return SurveyFullSurveySessionValuesModel.attributeTypeMap;
    }
}
SurveyFullSurveySessionValuesModel.discriminator = undefined;
SurveyFullSurveySessionValuesModel.additionalProperties = false;
SurveyFullSurveySessionValuesModel.attributeTypeMap = [
    {
        "name": "sessionValues",
        "baseName": "sessionValues",
        "type": ""
    },
];
//# sourceMappingURL=surveyFullSurveySessionValuesModel.js.map